export default "__VITE_ASSET__DluVNpH1__"